import { Helmet } from "react-helmet-async"
import { Navigate, Route, Routes } from "react-router-dom"
import { LandingPage } from "../LandingPage"
import { MainLayout } from "../MainLayout"
import { ProtectedRoute } from "../ProtectedRoute"
import { Providers } from "../Providers"
import { ReferralReview } from "../ReferralReview"
import { Referrals } from "../Referrals"
import { MainPage } from "../MainPage"
import { Form } from "../Form"
import { UploadLandingPage } from "../UploadLandingPage"
import { ToastsMessages } from "../ToastMessage/ToastMessages"
import { EnvironmentService } from "../../services/EnvironmentService"
import { SubmitError } from "../SubmitStates/SubmitError"
import { SubmitSuccess } from "../SubmitStates/SubmitSuccess"

export function App() {
  return (
    <Providers>
      <Helmet>
        <meta
          httpEquiv="Content-Security-Policy"
          content={`
            child-src 'self' blob:;
            connect-src 'self' https://logrocket.tranquility.app ${EnvironmentService.getApiBaseUrl()} ${EnvironmentService.getAuth0Domain()} https://app.launchdarkly.com https://clientstream.launchdarkly.com https://events.launchdarkly.com; 
            default-src 'self';
            worker-src 'self' blob:;
            form-action 'self' ${EnvironmentService.getAuth0Domain()};
            frame-src https://www.google.com/recaptcha/ https://recaptcha.google.com/recaptcha/ ${EnvironmentService.getAuth0Domain()};
            base-uri 'none';
            object-src 'none';
            script-src-elem 'self' ${EnvironmentService.getApiBaseUrl()} https://www.google.com/recaptcha/ https://www.gstatic.com/recaptcha/ ${EnvironmentService.getAuth0Domain()};
            script-src 'self' https://logrocket.tranquility.app;
            style-src 'self' 'unsafe-inline';
          `}
        />
      </Helmet>
      <ToastsMessages />
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route path=":province" element={<ProtectedRoute />}>
            <Route index element={<LandingPage />} />
            <Route path="steps" element={<MainPage />}>
              <Route path=":step" element={<Form />} />
              <Route index element={<Navigate to="1" replace />} />
            </Route>
            <Route path="error" element={<SubmitError />} />
            <Route path="success" element={<SubmitSuccess />} />
            <Route path="upload" element={<UploadLandingPage />} />
          </Route>
          <Route index element={<Navigate to="ontario" replace />} />
          <Route path="manage" element={<ProtectedRoute />}>
            <Route index element={<Referrals />} />
            <Route path=":referralId" element={<ReferralReview />} />
            <Route
              path=":referralId/edit"
              element={<ReferralReview edit={true} />}
            />
          </Route>
        </Route>
      </Routes>
    </Providers>
  )
}
